import {
    Box,
    FormControl,
    Grid,
    Paper,
    RadioGroup,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from "@mui/material";
import {numberWithPoints} from "../../../../utils/numberWithPoints";
import {normalizeTimestemp} from "../../../../utils/normalizeTimestemp";
import React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";

export default function InstallmentsRadioGroup(
    {installments, tittle, selectedInstallment, setInstallment}
) {

    const handleChange = (event) => {
        setInstallment(event.target.value);
    };

    return (
        <Grid item xs={6}>
            {/* Título fixo acima da tabela */}
            <Box sx={{bgcolor: 'black', color: 'white', textAlign: 'center', mt: 3, mb: 1}}>
                <Typography variant="h6" gutterBottom>
                    {tittle}
                </Typography>
            </Box>

            {/* Tabela com cabeçalho fixo e corpo rolável */}
            <TableContainer
                component={Paper}
                sx={{
                    maxHeight: '40vh',
                    overflow: 'auto',
                    textAlign: 'center',
                }}
            >
                <FormControl component="fieldset" sx={{width: '100%'}}>
                    <RadioGroup value={selectedInstallment} onChange={handleChange}>
                        <Table stickyHeader size="small" aria-label="tabela de parcelas">
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{backgroundColor: '#f5f5f5', fontWeight: 'bold'}}></TableCell>
                                    <TableCell sx={{backgroundColor: '#f5f5f5', fontWeight: 'bold'}}>Parcela</TableCell>
                                    <TableCell sx={{backgroundColor: '#f5f5f5', fontWeight: 'bold'}}>Valor</TableCell>
                                    <TableCell sx={{backgroundColor: '#f5f5f5', fontWeight: 'bold'}}>Vencimento</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {installments?.map((parcela, idx) => (
                                    <TableRow key={idx}>
                                        <TableCell
                                            sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                            <FormControlLabel
                                                value={parcela.id}
                                                control={<Radio/>}
                                                label={null}
                                            />
                                        </TableCell>
                                        <TableCell>{parcela.numero}</TableCell>
                                        <TableCell>R$ {numberWithPoints(parcela.valor)}</TableCell>
                                        <TableCell>{normalizeTimestemp(parcela.vencimento)}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </RadioGroup>
                </FormControl>
            </TableContainer>
        </Grid>
    );
}
